const consentModal = require('./consentModal');
const guestModal = require('./guestModal');

/**
 * @enum {string}
 */
const INIT_PARAM_PAGE = {
    CART: 'cart',
    CHECKOUT: 'checkout',
    LOGIN: 'checkout'
};

/**
 * Initialize the abandoned cart modals
 * @param {INIT_PARAM_PAGE} page The current page
 */
function init(page) {
    if (page === INIT_PARAM_PAGE.CART) {
        guestModal.init();
    } else if (page === INIT_PARAM_PAGE.CHECKOUT) {
        consentModal.init();
        guestModal.init();
    } else if (page === INIT_PARAM_PAGE.LOGIN) {
        consentModal.init();
        guestModal.init();
    }
}

module.exports = {
    init,
    INIT_PARAM_PAGE
};
